
jQuery(document).ready(function($) {

    const viewOptions = $('.view-options');
    if (viewOptions.length) {

        const saveViewOptions = function(){
            const selectValues = {};
            viewOptions.find('select').each(function(selectIndex, select){
                const selectId = $(this).attr('name');
                const selectValue = $(this).val();
                if (selectId) {
                    selectValues[selectId] = selectValue;
                }
            });

            console.log(selectValues);
            localStorage.setItem('viewOptions', JSON.stringify(selectValues));
        }
        const loadViewOptions = function() {
            const savedValues = JSON.parse(localStorage.getItem('viewOptions'));
            if (savedValues) {
                $.each(savedValues, function (key, value) {
                    $('.view-options select[name="' + key + '"]').val(value).change();
                });
            }
        }
        const applyViewOptions = function(){
            $('main').removeAttr('class');
            $('.view-options select').each(function(selectIndex, select){
                select = $(select);
                let className = select.attr('name') + '-' + select.val();
                $('main').addClass(className);
            });
        }

        viewOptions.on('change', 'select', function(){
            applyViewOptions();
            saveViewOptions();
        });

        $(document).ready(function(){
            loadViewOptions();
            applyViewOptions();
        });
    }

});


